import { Editor } from '@tiptap/core';
import { toaster } from 'helpers/toaster';
import { notifyException } from 'services/appsignal';
import { ESpansException } from 'types/ESpans';

export const docxToFile = async (editor: Editor | null, text: string, filename = 'data') => {
  editor?.commands.setContent(text ?? '');

  const file = await new Promise<File | null>((res, rej) => {
    editor
      ?.chain()
      ?.export({
        format: 'docx',
        onExport: (context) => {
          if (context?.error) {
            notifyException(context?.error, ESpansException.AiException);
            toaster.error('Something happened');
            return rej();
          }

          const fileBlob = context?.blob as Blob;
          const file = new File([fileBlob], `${filename}.docx`, {
            type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
          });
          return res(file);
        }
      })
      ?.run();
  });

  return file as File;
};
